export const cartLinksData = [
  '/cart',
  '/cart/shipping',
  '/cart/payment',
  '/cart/review-order',
];

export { cartLinksData as default };
